import { RenderState } from "@/services/render/types";
import { RootState } from "@/store/types";
import { ActionTree } from "vuex";

export const actions: ActionTree<RenderState, RootState> = {
    setRenderPostStatistic(context, payload) {
        context.commit("setRenderPostStatistic", payload);
    },
    clearRenderStatistics(context, payload) {
        context.commit("clearRenderStatistics");
    },
    setCurrentSolutionTimezoneId(context, payload) {
        context.commit("setCurrentSolutionTimezoneId", payload);
    },
    setAllowedOrigins(context, payload) {
        context.commit("setAllowedOrigins", payload);
    }
};
